import styled, { css } from 'styled-components'

export const SwitchWrapper = styled.div`
  padding: 26px 0 16px;
  button {
    float: right;
  }
`

export const SwitchTitle = styled.div`
  color: #363636;
  font-size: 14px;
  padding-bottom: 6px;
`

export const SwitchSubtitle = styled.div`
  color: #757575;
  font-size: 14px;
`

export const Container = styled.div`
  margin-top: 16px;
  border: 2px solid #d9d9d9;
  border-radius: 8px;
  padding: 24px;
`

export const Header = styled.div`
  height: 32px;
  button {
    float: right;
    padding: 0 5px;
    color: #213f68 !important;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
  }
`

export const Title = styled.div`
  float: left;
  padding: 4px 0;
  font-weight: 700;
`

export const Options = styled.div`
  text-align: right;
  button {
    font-weight: 700;
    padding: 0 8px;
    color: #4c4c4c !important;
    border-radius: 8px;
    background-color: #f0f0f0 !important;
    margin-left: 8px;
    border: none;
    &:hover {
      color: #4c4c4ca6 !important;
    }
    &:disabled {
      color: #4c4c4c !important;
      opacity: 0.48;
    }
  }
`

interface IContentProps {
  open: boolean
}

export const Content = styled.div<IContentProps>`
  overflow: hidden;
  transition: 200ms;
  tr:hover > td {
    background-color: unset !important;
  }
  .ant-row {
    margin-top: -1px;
    margin-bottom: -32px;
  }
  ${(props) =>
    !props.open &&
    css`
      height: 0;
    `}
`

export const AddLearningPaths = styled.div`
  button {
    color: #2684ff;
    height: 40px;
    margin-top: 8px;
    font-weight: 700;
    svg {
      margin-right: 8px;
    }
  }
`
